import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ReplaceCaptureParams } from "../../../domain/entities/compliance";
import { type ComplianceDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";
import { getCase } from "./get-case";

/**
 * Replaces one evidence photo and reloads the case, so the checklist shows the
 * new image and the history shows the change that was just recorded.
 */
export const replaceCapture = createAsyncThunk<
  void,
  ReplaceCaptureParams,
  { dispatch: ComplianceDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.REPLACE_CAPTURE, async (params, { dispatch, extra }) => {
  await extra.complianceRepo.replaceCapture(params);
  await dispatch(getCase({ requestId: params.requestId }));
});
